import APIConfig from '../../config/api';
import { APIService } from '../axiosInstance';
import { IBankCodeType, IBank } from '../../typings/accounting/bank';
import { FetchParamsModel, FetchResponseModel } from '../../typings/common';

interface IFetchBanksParams extends FetchParamsModel {
  bankCode: string;
  bankCodeTypeId: number;
}

const banksAPI = {
  fetchBanks: (fetchBanksParams: IFetchBanksParams) => {
    return APIService.get(`${APIConfig.accountingApi}/banks/codes/suggest`, {
      params: fetchBanksParams,
    }).then<FetchResponseModel<IBank>>(({ data }) => data);
  },

  fetchBankCodeTypes() {
    return APIService.get(`${APIConfig.accountingApi}/banks/codes/types`).then<
      FetchResponseModel<IBankCodeType>
    >(({ data }) => data);
  },
};

export { banksAPI };
